export default __webpack_public_path__ + "static/media/service1.28bf5688.png";